var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1081 11.1111H5.55585C5.43363 11.1111 5.33364 11.2111 5.33364 11.3333V13C5.33364 13.1222 5.43363 13.2222 5.55585 13.2222H20.5887L16.5805 18.3056C16.4666 18.45 16.5694 18.6667 16.7555 18.6667H18.7693C18.9055 18.6667 19.0332 18.6056 19.1193 18.4972L23.8081 12.55C24.2664 11.9667 23.8525 11.1111 23.1081 11.1111ZM18.4442 5.44444H3.41132L7.41955 0.361111C7.53344 0.216667 7.43066 0 7.24456 0H5.23072C5.09461 0 4.96684 0.0611113 4.88073 0.169445L0.191965 6.11667C-0.266356 6.7 0.147522 7.55556 0.889169 7.55556H18.4442C18.5664 7.55556 18.6664 7.45555 18.6664 7.33333V5.66667C18.6664 5.54444 18.5664 5.44444 18.4442 5.44444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.794b93e6be33fe8852d74597e4997ba1.svg";
export { ForwardRef as ReactComponent };